export default __webpack_public_path__ + "static/media/7-1.eb8c94c5.gif";